import { LazyLoadImage } from "react-lazy-load-image-component";
import { desktopThumbnail, mobileThumbnail } from "../../constants/finance";
import { useMobile } from "../../utils/findViewport";
import { Context } from "../../context/context";
import { Box, styled } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

const CustomSwiperBox = styled(Box)(({ theme }) => ({
  ".swiper-box": {
    margin: "0px 100px",
  },
  ".image-section": {
    objectFit: "contain",
    height: "500px !important",
    width: "250px !important",
    position: "relative !important",
  },
  ".swiper-turno-india": {
    display: "block",
    ".swiper-wrapper": {
      alignItems: "center",
    },
    ".swiper-slide": {
      display: "flex",
      justifyContent: "center",
      ".thumbanil-box": {
        transform: "scale(0.8)",
      },
    },
    ".swiper-slide.swiper-slide-active": {
      ".thumbanil-box": {
        transform: "scale(1)",
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    margin: " 40px 28px",
    ".image-section": {
      objectFit: "contain",
      height: "300px !important",
      width: "200px !important",
      position: "relative !important",
    },
    ".swiper-box": {
      margin: "0px",
    },
    ".swiper-turno-india": {
      marginTop: "40px",
      display: "block",
      ".swiper-wrapper": {
        alignItems: "center",
      },
      ".swiper-slide": {
        display: "flex",
        justifyContent: "center",
        ".thumbanil-box": {
          transform: "scale(0.7)",
        },
      },
      ".swiper-slide.swiper-slide-active": {
        ".thumbanil-box": {
          transform: "scale(1)",
        },
      },
    },
  },
}));
const SwiperBox = () => {
  const mobile = useMobile();
  const { showReviewStoryDrawer } = useContext(Context);
  const [thumbnailArray, setThumbnailArray] = useState(desktopThumbnail);
  const [slidesPerView, setSlidesPerView] = useState(desktopThumbnail.length);
  useEffect(() => {
    if (mobile) {
      setThumbnailArray(mobileThumbnail);
      setSlidesPerView(mobileThumbnail.length - 1);
    } else {
      setThumbnailArray(desktopThumbnail);
      setSlidesPerView(desktopThumbnail.length);
    }
  }, [mobile]);
  return (
    <CustomSwiperBox>
      <Box className="swiper-box">
        <Swiper
          slidesPerView={slidesPerView}
          spaceBetween={0}
          centeredSlides={true}
          pagination={false}
          loop={true}
          modules={[Pagination]}
          className="swiper-turno-india"
        >
          {thumbnailArray.map((data, index) => {
            return (
              <SwiperSlide key={index}>
                <Box className="thumbanil-box">
                  <LazyLoadImage
                    src={data.imageName}
                    fill="true"
                    alt="Turno home Icon"
                    className={"image-section"}
                    effect="opacity"
                    onClick={() => {
                      showReviewStoryDrawer();
                    }}
                  />
                </Box>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Box>
    </CustomSwiperBox>
  );
};

export default SwiperBox;
